<template>
    <div class="page">
 <box>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input v-model="picture.query.boxBarcode" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="操作人" class="EL-Form-Item">
                        <el-input v-model="picture.query.person" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="picture.query.beginTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="picture.query.endTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="finishPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getUploadFile()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData('picture')">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                
            </el-form>
            <plabel text="图片管理">
                <el-button class="btn-t-delete" @click="deletePicture()" v-authority="'BACK_MENU3_M12_B1'">
                    照片删除
                </el-button>
            </plabel>
            <h-table :data="picture.data" @pageChange="getUploadFile" :headerCellStyle="picture.headerCellStyle" :style="$popups.harvestRecordStyle(0.8)" pagination :nowPage.sync="picture.pageNum" :pageSize.sync="picture.pageSize" :total.sync="picture.total" @selectionChange="pictureSelectAll">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="箱号" prop="boxBarcode" align="center">
                </el-table-column>
                <el-table-column label="描述" prop="remark" align="center">
                </el-table-column>
                <el-table-column label="操作人" prop="person" align="center">
                </el-table-column>
                <el-table-column label="操作时间" prop="updateTime" align="center">
                </el-table-column>
                <el-table-column label="图片" align="center">
                    <template slot-scope="scope">
                        <div class="demo-image__preview">
                            <el-image 
                                style="width: 50px;"
                                :src="scope.row.ufAddress" 
                                :preview-src-list="srcList">
                            </el-image>
                        </div>
                        <!-- <img class="imgPhotograph" :src="scope.row.ufAddress"> -->
                    </template>
                </el-table-column>
                <!-- ufAddress -->
            </h-table>
        </box>
    </div>
</template>

<script>
export default {
    name:"Photograph",
    data(){
        return{
            picture:{
                query:{
                    boxBarcode:"", 
                    fcCode: localStorage.getItem("fcCode"),
                    person:"",  
                    beginTime:"", 
                    endTime:"",
                },
                data: [],
                pageNum: 1,
                pageSize: 50,
                total: 0,
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },
            },
            // 放大的图片
            srcList:[],
            /* 选择的图片 */
            checkList:[],
            // 输入框延时加载
            isSetTimeout: null,
        }
    },
    watch:{
        "picture.query": {
            handler() {
                clearTimeout(this.isSetTimeout);
                    this.isSetTimeout = setTimeout(() => {
                    this.getUploadFile();
                }, 1000);
            },
            deep: true,
        },
    },
    computed: {
        startPickerOptions() {
            let _this = this;
            return {
                disabledDate(time) {
                    if (_this.picture.query.endTime) {
                        return time.getTime() > new Date(_this.picture.query.endTime);
                    }
                }
            }
        },
        finishPickerOptions() {
            let _this = this;
            return {
                disabledDate(time) {
                    if (_this.picture.query.beginTime) {
                        return time.getTime() < new Date(_this.picture.query.beginTime);
                    }
                }
            }
        },
    },
    methods:{
        /* 图片删除 */
        deletePicture(){
            this.$confirm("是否确认删除图片!", "提示",
            {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
            })
            .then(() => {
                var map = this.checkList.map(ele=>{
                    return ele.ufId
                })
                this.$http
                    .request({
                        url: "/api/uploadFile/deleteUploadFile",
                        method: "DELETE",
                        params:{
                            ufId: map.join(","),
                        }
                    })
                    .then((res) => {
                        console.log(res);
                        if (res.status == 100) {
                            this.getUploadFile();
                            this.$message({
                                message: "删除成功!",
                                type: 'success'
                            });
                        }else if (res.status == 500) {
                            this.$message.error("服务器异常!");
                        } else {
                            this.$message({
                                message: res.message,
                                type: 'warning'
                            });
                        }
                    });
            }).catch(()=>{
                this.$message({
                    type: "info",
                    message: "已取消",
                });
            });
        },
        /* 重置 */
        resetData(type){
            if (type =="picture") {
                this.picture.query = {
                    boxBarcode:"", 
                    fcCode: localStorage.getItem("fcCode"),
                    person:"",  
                    beginTime:"", 
                    endTime:"",
                };
            }
        },
        /* 选择图片 */
        pictureSelectAll(val){
            this.checkList = val;
        },
        /* 图片查询 */
        getUploadFile(){
            this.$http
                .request({
                    url: "/api/uploadFile/getUploadFile",
                    method: "GET",
                    params:{
                        pageNum: this.picture.query.pageNum, //	页号
                        pageSize: this.picture.query.pageSize, // 页大小
                        boxBarcode: this.picture.query.boxBarcode || "",
                        fcCode: this.picture.query.fcCode || "",
                        person: this.picture.query.person || "",
                        beginTime: this.picture.query.beginTime || "",
                        endTime: this.picture.query.endTime || "",
                    }
                })
                .then((res) => {
                    if (res.status == 100) {
                        console.log(res.data.list);
                        if (res.data.list) {
                            res.data.list.forEach(ele => {
                                ele.ufAddress = this.$pictureUil + ele.ufAddress;
                                console.log(ele.ufAddress);
                                this.srcList.push(ele.ufAddress);
                            });
                            this.picture.data = res.data.list;
                            this.picture.total = res.data.total;
                        }else{
                            this.picture.data = [];
                            this.picture.total = 0;
                        }
                    }
                });
        },
        
    },
    activated(){
        /* 获取首页的数据 */
        this.getUploadFile();
    },
}
</script>

<style lang="scss" scoped>
.imgPhotograph{
    width: 50px;
}
</style>